import {Icon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "42",
  height: "48",
  viewBox: "0 0 42 48",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M21 24c-6.627 0-12-5.373-12-12S14.373 0 21 0s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S26.523 2 21 2 11 6.477 11 12s4.477 10 10 10zM0 48c0-11.598 9.402-21 21-21s21 9.402 21 21h-2c0-10.493-8.507-19-19-19S2 37.507 2 48H0z",
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, null, -1)
  ]))]))
}
export default { render() { return h(Icon, {icon: {render}, name: "icon-user-xl"}) } }